import React from 'react';

const CandidateDetails = ({ selectedApp, talentAge, tp, handleViewCandidateProfile }) => {
  return (
    <div className="card-dark p-2.5 p-sm-3 p-md-4 rounded-3" style={{ background: '#121212', border: '1px solid rgba(255, 255, 255, 0.08)' }}>
      <div className="row g-2 g-sm-3 align-items-stretch">
        {/* Left Column: Audition Script */}
        <div className="col-6 pe-2 pe-sm-3 pe-md-4 border-end" style={{ borderColor: 'rgba(255, 255, 255, 0.15)' }}>
          <div className="fw-bold mb-2 mb-sm-3" style={{ fontSize: '0.875rem', color: '#dc2626' }}>
            Audition Script
          </div>
          <div 
            className="text-white-50" 
            style={{ 
              fontSize: '0.78rem', 
              lineHeight: '1.5', 
              maxHeight: '140px', 
              overflowY: 'auto',
              overflowX: 'hidden',
              wordBreak: 'break-word',
              whiteSpace: 'pre-wrap',
              paddingRight: '4px',
              scrollbarWidth: 'thin',
              scrollbarColor: '#4a5568 #121212'
            }} 
            dangerouslySetInnerHTML={{ __html: selectedApp?.c_roleScript || 'No script provided.' }} 
          />
        </div>

        {/* Right Column: Candidate Details */}
        <div className="col-6 ps-2 ps-sm-3 ps-md-4">
          <div className="fw-bold mb-2 mb-sm-3" style={{ fontSize: '0.875rem', color: '#dc2626' }}>
            Candidate Details
          </div>

          <div className="d-flex flex-column gap-2 gap-sm-2.5">
            <div className="text-white d-flex align-items-center" style={{ fontSize: '0.8rem' }}>
              <span style={{ width: '60px', color: '#8a94a6', fontSize: '0.78rem', display: 'inline-block', flexShrink: 0 }}>Name:</span>
              <span 
                className="fw-bold text-white text-decoration-underline text-truncate" 
                style={{ cursor: 'pointer' }}
                onClick={handleViewCandidateProfile}
                title="Click to view candidate profile"
              >
                {selectedApp?.talent_name || 'Candidate'}
              </span>
            </div>

            <div className="text-white d-flex align-items-center" style={{ fontSize: '0.8rem' }}>
              <span style={{ width: '60px', color: '#8a94a6', fontSize: '0.78rem', display: 'inline-block', flexShrink: 0 }}>Age:</span>
              <span className="fw-bold text-white">{talentAge || '---'} Yrs</span>
            </div>

            <div className="text-white d-flex align-items-center" style={{ fontSize: '0.8rem' }}>
              <span style={{ width: '60px', color: '#8a94a6', fontSize: '0.78rem', display: 'inline-block', flexShrink: 0 }}>Gender:</span>
              <span className="fw-bold text-white text-lowercase">{tp.gender || '---'}</span>
            </div>

            <div className="text-white d-flex align-items-center" style={{ fontSize: '0.8rem' }}>
              <span style={{ width: '60px', color: '#8a94a6', fontSize: '0.78rem', display: 'inline-block', flexShrink: 0 }}>Height:</span>
              <span className="fw-bold text-white">{tp.height ? `${tp.height} cm` : '---'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateDetails;